export const eventRoleFormInitialValues = {
  event_role: "",
  assigned_to: "",
  assigned_by: "",
};
